import { useState, Fragment } from 'react';
import { Trans } from '@lingui/react/macro';
import { IconButton, Menu, TableBodyCell } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useHistory } from 'react-router-dom';
import { useTeamRole } from 'app/domains/teams';
import { useRole } from 'app/domains/users';
import { ConfirmDeleteTeamDialog } from '../ConfirmDeleteTeamDialog';
export function ContextCell(props) {
    const { id, name } = props;
    const [deleteTeamDialog, setDeleteTeamDialog] = useState(false);
    const role = useRole();
    const teamRole = useTeamRole(id);
    const { push } = useHistory();
    const canDeleteTeam = role.can('delete:team') || teamRole.can('delete:team');
    const handleViewTeam = () => {
        push(`users-teams/team/${id}`);
    };
    const handleDeleteTeam = () => {
        setDeleteTeamDialog(true);
    };
    return (<Fragment>
      <TableBodyCell removeExtraPadding headers="menu" stickyColumn="right">
        <Menu.Root target={<IconButton appearance="ghost" size="xs">
              <Falcon icon="ellipsis-h"/>
            </IconButton>}>
          <Menu.Item onClick={handleViewTeam}>
            <Falcon icon="eye"/>
            <Trans comment="team context menu - view team list item">View Team</Trans>
          </Menu.Item>
          {canDeleteTeam && (<Menu.Item onClick={handleDeleteTeam}>
              <Falcon icon="trash"/>
              <Trans comment="team context menu - delete team list item">Delete Team</Trans>
            </Menu.Item>)}
        </Menu.Root>
      </TableBodyCell>
      {deleteTeamDialog && <ConfirmDeleteTeamDialog id={id} onClose={() => setDeleteTeamDialog(false)} name={name}/>}
    </Fragment>);
}
